<template>
  <div id="app">
    <div v-if="$root.env.init">
      <Navbar v-if="$route.name !== 'empty'" />
      <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
      <b-modal :active.sync="!$root.env.auth.success"
               full-screen :can-cancel="false">
              <Login />
      </b-modal>
      <transition name="tra-fade">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>

// @ is an alias to /src
import Login from '@/components/Login.vue'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'home',
  components: {
    Login,
    Navbar
  },
  computed: {
    loading(){
      return this.$root.env.loading.public !== 0;
    }
  }
}
</script>


<style lang="scss">

@import './scss/bootstrap.scss';

.tra-fade-enter-active, .tra-fade-leave-active {
  transition: opacity .5s;
}
.tra-fade-enter, .tra-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#app>div:first-child{
  width: 100%;
  position: absolute;
}
  #app>div>div.event,
  #app>div>div.home{
    height: 0;
    margin-top: 50px;
  }

</style>
